import { PowerSocketUsIcon } from './PowerSocketUsIcon';

/**
 * author: GreenTurtwig
 * id C4F7F8FF-3465-4F85-B615-B852A6919100
 * name power-socket-us
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-us.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketUnitedStatesIcon = PowerSocketUsIcon;
export default PowerSocketUnitedStatesIcon